module.exports = __webpack_public_path__ + "assets/6af15be2ecc974b98ebf38deacc3b6ae.svg";